import {useMemo} from 'react';
import {type List} from 'immutable';

import {addGenericErrorToast} from '@albert-io/atomic';
import {type ClassroomInvitationModelV1} from '@albert-io/models';
import getClassroomInvitationsQuery from '../queries/getClassroomInvitationsQuery';
import {useStudentHomepageStore} from '../../useStudentHomepageStore';

export default function useClassroomInvitations() {
  const areInvitationsLoading = useStudentHomepageStore((state) => state.areInvitationsLoading);
  const invitations = useStudentHomepageStore((state) => state.invitations);
  const setAreInvitationsLoading = useStudentHomepageStore((state) => state.setAreInvitationsLoading);
  const setInvitations = useStudentHomepageStore((state) => state.setInvitations);
  const studentEmail = useStudentHomepageStore((state) => state.studentEmail ?? '');

  const query = useMemo(() => getClassroomInvitationsQuery(studentEmail), [studentEmail]);

  function fetchClassroomInvitations() {
    setAreInvitationsLoading(true);

    query.invalidateInterest();

    query
      .getResourcePromise()
      .then((fetchedInvitations) => {
        // JSON:API getResourcePromise resolves as `unknown`; the endpoint returns
        // a List of ClassroomInvitationModelV1, matching the store's expected type.
        setInvitations(fetchedInvitations as List<ClassroomInvitationModelV1>);
      })
      .catch((error) => {
        console.error(error);
        addGenericErrorToast();
      })
      .finally(() => {
        setAreInvitationsLoading(false);
      });
  }

  return {areInvitationsLoading, fetchClassroomInvitations, invitations};
}
